import Box from "@mui/material/Box";
import {Legend, Pie, PieChart, ResponsiveContainer} from "recharts";
import * as React from "react";

interface HalfPieChartProps {
    height: number;
    data: any;
}

export default (props: HalfPieChartProps) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: props.height,
        }}>
            <ResponsiveContainer>
                <PieChart margin={{top: 10}}>
                    <Pie
                        style={{fontSize: '.95rem', outline: 'none'}}
                        dataKey="value"
                        nameKey="status"
                        startAngle={180}
                        endAngle={0}
                        data={props.data}
                        cx="50%"
                        cy="100%"
                        outerRadius={100}
                         // paddingAngle={}
                        label
                    />
                    <Legend
                        verticalAlign="bottom"
                        wrapperStyle={{fontSize: '.85rem', bottom: '-10px'}}/>
                </PieChart>
            </ResponsiveContainer>
        </Box>
    )
}